import api from "@/utils/backend-api";
import {
   commitPagination,
} from "@/utils/store-util.js";

import { get } from "lodash";

const state = {
  items: [],
  pagination: {},
  loading: true,
  snackbar: false,
  customer: '',
  orders: [],
  appraises: [],
  sources: [],
};

const getters = {};

const actions = {
  getCustomerById ({ commit }, id) {
    commit("setCustomer", []);
    commit("setLoading", { loading: true });
      api.getData("contragents?id=" + id).then(
        res => {
          const customer = res.data;
          commit("setCustomer", customer);
          commit("setLoading", { loading: false });
        },
        err => {
          console.log(err);
        }
      );
  },
  getCustomerOrders ({ commit }, id) {
    commit("setLoading", { loading: true });
      api.getData("contragents/orders?id=" + id).then(
        res => {
          const orders = res.data;
          commit("setCustomerOrders", { orders });
          commit("setLoading", { loading: false });
        },
        err => {
          console.log(err);
        }
      );
  },
  getCustomerAppraises ({ commit }, id) {
      api.getData("contragents/appraises?id=" + id).then(
        res => {
          const appraises = res.data;
          commit("setCustomerAppraises", { appraises });
        },
        err => {
          console.log(err);
        }
      );
  },
  getCustomerSourcesAppraises ({ commit }, id) {
      api.getData("contragents/sources?id=" + id).then(
        res => {
          const appraises = res.data;
          commit("setCustomerSourcesAppraises", { appraises });
        },
        err => {
          console.log(err);
        }
      );
  },
  quickSearch ({ commit }, { headers, qsFilter, pagination }) {
    commitPagination(commit, []);
    api.getData("contragents?qs=" + qsFilter).then(res => {
      commitPagination(commit, res.data);
    });
  },
};

const mutations = {
  setItems (state, customers) {
    state.items = customers;
  },
  setCustomer (state, customer) {
    state.customer = customer;
  },
  setCustomerOrders (state, orders) {
    state.orders = orders;
  },
  setCustomerAppraises (state, appraises) {
    state.appraises = appraises;
  },
  setCustomerSourcesAppraises (state, appraises) {
    state.sources = appraises;
  },
  setPagination (state, pagination) {
    state.pagination = pagination;
  },
  setLoading (state, { loading }) {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/contragents.js